import * as React from 'react';
import {
  withStyles,
  Arwes,
  Content,
  Row,
  Col,
  Words,
  Frame,
  Image,
  Button,
  Loading,
  createLoader,
  createResponsive,
  utils,
} from 'arwes';
import { Machine, assign } from 'xstate';
// import { StateChart, Mac } from '@statecharts/xstate-viz';
import FalconContext from '../contexts/falcon.context';
import { makeFalconStateChart, SPEECH_TEXTS } from '../model/falcon-machine';
import AssembledFalcon from '../components/assembled-falcon';
import CountdownTimer from '../components/countdown-timer';
import Link from '../components/link';

interface ToggleContext {
  count: number;
}

const toggleMachine = Machine<any>({
  id: 'toggle',
  initial: 'inactive',
  context: {
    count: 0,
  },
  states: {
    inactive: {
      on: { TOGGLE: 'active' },
    },
    active: {
      entry: assign({ count: ctx => ctx.count + 1 }),
      on: { TOGGLE: 'inactive' },
    },
  },
});

const styles = theme => {
  return {
    root: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 5px',
    },
    mainHeader: {
      width: '100%',
      '& h1': {
        margin: 10,
      },
    },
    main: {
      height: '100%',
      width: '100%',
    },
    fullHeightColumn: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'stretch',
      height: '100%',
      flexDirection: 'column',
    },
    falconComplete: {
      // position: 'relative',
    },
    rocketPanel: {
      width: '1050px',
    },
    textPanel: {
      width: 'calc(100% - 1050px)',
    },
    frame: {
      display: 'flex',
      flexGrow: 1,
      justifyContent: 'center',
      overflow: 'hidden',
      position: 'relative',
    },
    controlPanel: {
      margin: 55,

      '& h1': {
        fontSize: 60,
        margin: 20,
      },

      '& button': {
        fontSize: 40,
      },
    },
    finalStatusPanel: {
      margin: '40px 20px 20px',
    },
  };
};

class Panel extends React.Component<any, any> {
  public falcon9;
  public loader;
  public responsive;
  private falconStateMachine;

  constructor(props: any) {
    super(props);
    this.state = {
      show: false,
      loaded: false,
      falconState: {
        state: 'idle',
      },
      dialogue: '',
      countdownTimerState: 'STOP',
    };

    console.log('PROPS: ', this.props);

    this.falcon9 = '/assets/falcon9-complete.png';

    this.loader = createLoader();
    this.responsive = createResponsive({
      getTheme: () => this.props.theme,
    });

    this.falconStateMachine = makeFalconStateChart({});

    this.falconStateMachine.onTransition(machineState => {
      if (machineState.changed) {
        console.log('FALCON STATE TRANSITION: ', machineState, machineState.value);
        this.setState({
          falconState: {
            state: machineState.value,
          },
          dialogue: SPEECH_TEXTS[machineState.value],
        });

        if (machineState.value === 'precheck') {
          this.setState({
            countdownTimerState: 'START',
          });
        }

        if (machineState.value === 'end') {
          this.setState({
            countdownTimerState: 'STOP',
          });
        }
      }
    });
  }

  componentDidMount() {
    this.startLoading();
    this.falconStateMachine.start();
  }

  initiateLaunchSequence() {
    this.falconStateMachine.send('INITIATE_LAUNCH_SEQUENCE');
  }

  startLoading() {
    const responsive = this.responsive.get();
    const background = utils.getResponsiveResource(this.props.resources.background, responsive);

    this.loader
      .load({ images: [background, this.falcon9] }, { timeout: 5 * 1000 })
      .then(
        () => {},
        () => {},
      )
      .then(() => {
        setTimeout(() => {
          this.setState({ show: true, loaded: true });
        }, 1);
      });
  }

  onLink = () => {
    this.setState({ show: false });
  };

  render() {
    const { show, loaded } = this.state;
    const { classes, resources } = this.props;
    const { background, pattern } = resources;

    return (
      <div className="main">
        <Loading
          full
          animate
          show={!show && !loaded}
          animation={{
            unmountOnExit: true,
          }}
        />
        <Arwes animate show={show} showResources={show} background={background} pattern={pattern}>
          {anim => (
            <Content className={classes.root}>
              <Row className={classes.mainHeader}>
                <Col s={8} className={`${classes.fullHeightColumn} ${classes.rocketPanel}`}>
                  <div className={`${classes.frame}`}>
                    <div className={classes.falconComplete}>
                      <FalconContext.Provider value={this.state.falconState}>
                        <AssembledFalcon />
                      </FalconContext.Provider>
                    </div>
                  </div>
                </Col>
                <Col s={4} className={`${classes.fullHeightColumn} ${classes.textPanel}`}>
                  <Row>
                    <Col s={12}>
                      <Frame animate show={anim.entered} level={1} corners={3}>
                        <Content>
                          <h1>Falcon9 Simulator</h1>
                        </Content>
                      </Frame>
                    </Col>
                  </Row>
                  <Row className={classes.main}>
                    <Col s={12} className={classes.fullHeightColumn}>
                      <Frame
                        animate
                        className={classes.frame}
                        show={anim.entered}
                        corners={3}
                        noBackground>
                        <div className={classes.controlPanel}>
                          <CountdownTimer timerState={this.state.countdownTimerState} />
                          <Button
                            disable={this.state.falconState.state !== 'idle' ? 'true' : undefined}
                            layer={
                              this.state.falconState.state === 'idle' ? 'primary' : 'secondary'
                            }
                            animate
                            show={anim.entered}
                            onClick={() => this.initiateLaunchSequence()}>
                            {anim2 => (
                              <Words animate show={anim2.entered}>
                                {this.state.falconState.state === 'idle'
                                  ? 'LAUNCH'
                                  : 'LAUNCH STARTED'}
                              </Words>
                            )}
                          </Button>
                          {this.state.falconState.state !== 'idle' &&
                          this.state.falconState.state !== 'end' ? (
                            <div className={classes.finalStatusPanel}>
                              <h2>{this.state.dialogue}</h2>
                            </div>
                          ) : null}
                          {this.state.falconState.state === 'end' ? (
                            <div className={classes.finalStatusPanel}>
                              <h2>{'Simulation Complete'.toLocaleUpperCase()}</h2>
                              <h2>{'Launch Successful!'.toLocaleUpperCase()}</h2>
                            </div>
                          ) : null}
                        </div>
                      </Frame>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Content>
          )}
        </Arwes>
      </div>
    );
  }
}

export default withStyles(styles)(Panel);
